import "./PortfolioRoadmap.css";

import { EmptyRoadmapIcon, RoundedPlusSignIcon } from "../../../../assets";
import { Button, Column, GanttChart, Row } from "../../../../widget";
import { SelectDealsModal } from "./components";
import { usePortfolioRoadmapPage } from "./usePortfolioRoadmapPage";

const PortfolioRoadmap = (): JSX.Element => {
  const {
    errors,
    ganttRows,
    onRowClick,
    dealsMultiSelectData,
    roadmapDealUuids,
    setRoadmapDealUuids,
    showAddDealsModal,
    setShowAddDealsModal,
    closeSelectDealsModal,
    onSaveDealsSelectData,
    isLoading,
    fetchSelectData,
    hasData,
  } = usePortfolioRoadmapPage();

  return (
    <div className="PortfolioRoadmapWrapper">
      <Row>
        <Column span={12}>
          <div className="PortfolioRoadmapHeader">
            <h2 className="PortfolioRoadmapTitle">Deal roadmap</h2>
          </div>
        </Column>
      </Row>
      {(hasData || isLoading) && (
        <GanttChart
          variant="project-roadmap"
          mode="stage"
          rows={ganttRows}
          isLoading={isLoading}
          onRowClick={onRowClick}
          onEditProjectsClick={() => setShowAddDealsModal(true)}
          onAddObjectsClick={() => setShowAddDealsModal(true)}
        />
      )}
      {!hasData && !isLoading && (
        <div className="EmptyRoadmap">
          <EmptyRoadmapIcon />
          <h1>Your roadmap is almost ready</h1>
          <p className="body1">Add deals to populate your roadmap.</p>
          <Button
            className="AddDealsButton"
            text="Add deals"
            icon={<RoundedPlusSignIcon className="RoundedPlusSignIcon" />}
            iconPosition="left"
            onClick={() => setShowAddDealsModal(true)}
            corners="rounded"
          />
        </div>
      )}
      <SelectDealsModal
        errors={errors}
        roadmapDealUuids={roadmapDealUuids}
        setRoadmapDealUuids={setRoadmapDealUuids}
        dealsMultiSelectData={dealsMultiSelectData}
        onSaveDealsSelectData={onSaveDealsSelectData}
        show={showAddDealsModal}
        closePanel={closeSelectDealsModal}
        fetchSelectData={fetchSelectData}
      />
    </div>
  );
};

export default PortfolioRoadmap;
